import { HighlightsStory } from "@/components/HighlightsStory";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const ServicesSection = () => {
  const scrollToContact = () => {
    document.getElementById("contact-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services-section" className="py-16 sm:py-20 lg:py-32 bg-muted/50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 animate-fade-in px-2">
              Perfect Music for Every Moment
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto animate-fade-in [animation-delay:100ms] px-4">
              From the first dance to the final toast—we craft soundscapes that transform ordinary events into legendary experiences
            </p>
          </div>

          <HighlightsStory />

          {/* CTA after services */}
          <div className="text-center mt-8 sm:mt-12">
            <Button 
              size="lg"
              onClick={scrollToContact}
              className="w-full sm:w-auto shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 transition-all duration-300 group"
            >
              Book Your Musicians
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
